var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiColorCompass = function SvgMultiColorCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#130E3A",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F71278",
    d: "m10.8 10.802 2.4 2.4 2.766-4.839c.12-.211-.115-.447-.327-.326z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#46C3F0",
    d: "m13.2 13.197-2.4-2.4-2.765 4.838c-.121.212.115.447.326.327z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.6 12.002a.6.6 0 1 1-1.199 0 .6.6 0 0 1 1.2 0"
  })));
};
export { SvgMultiColorCompass as ReactComponent };